const STATES = [
  {
    abbr: 'NSW',
    display: 'New South Wales',
  },
  {
    abbr: 'QLD',
    display: 'Queensland',
  },
  {
    abbr: 'SA',
    display: 'South Australia',
  },
  {
    abbr: 'TAS',
    display: 'Tasmania',
  },
  {
    abbr: 'VIC',
    display: 'Victoria',
  },
  {
    abbr: 'WA',
    display: 'Western Australia',
  },
  {
    abbr: 'NT',
    display: 'Northern Territory',
  },
  {
    abbr: 'ACT',
    display: 'Australian Capital Territory',
  },
];

export default STATES;
